import React from 'react';
import {useCss} from 'react-use';
import classNames from 'classnames';

type DivElementProps = Pick<
    React.HTMLAttributes<HTMLDivElement>,
    'onClick' | 'title' | 'hidden'
>;

export interface FlexBoxProps extends React.CSSProperties, DivElementProps {
    className?: string;
    children?: React.ReactNode;
}

export const FlexBox = React.forwardRef<HTMLDivElement, FlexBoxProps>(
    ({children, className, onClick, title, hidden, ...cssProps}, ref) => {
        const cssClass = useCss({display: 'flex', ...cssProps});

        return (
            <div
                ref={ref}
                className={classNames(cssClass, className)}
                onClick={onClick}
                title={title}
                hidden={hidden}>
                {children}
            </div>
        );
    },
);

FlexBox.defaultProps = {
    alignItems: 'center',
};
